export default "__VITE_ASSET__DlluAuq0__"